module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "switch_pin_type"
  }, [_c('div', {
    class: ['switch_pin_type-button', {
      'is-current': _vm.includesSpotsPin
    }],
    on: {
      "click": function($event) {
        return _vm.switchVisualizationPinType('spots')
      }
    }
  }, [_c('icon-spot', {
    attrs: {
      "width": "45px",
      "height": "45px"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch_pin_type-label"
  }, [_vm._v("\n      場所\n    ")])], 1), _vm._v(" "), _c('div', {
    class: ['switch_pin_type-button', {
      'is-current': _vm.includesPersonsPin
    }],
    on: {
      "click": function($event) {
        return _vm.switchVisualizationPinType('persons')
      }
    }
  }, [_c('icon-person', {
    attrs: {
      "width": "45px",
      "height": "45px"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch_pin_type-label switch_pin_type-label--person"
  }, [_vm._v("\n      人\n    ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-038aee49","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/map/controller/switch_pin_type.vue
// module id = 803
// module chunks = 0